/**
 * Giftie Integration
 * - Magic Writer text generation (homepage gift form) - uses old gifttaggSDK
 * - Video recording - uses new Giftie SDK
 */

let generatedMessage = "";

// ============================================
// Magic Writer Configuration (old gifttaggSDK)
// ============================================

const handleGenerateGiftnote = function (gifttagg, magicWriter) {
  var message = "";
  if (gifttagg !== undefined && magicWriter === undefined) {
    message =
      gifttagg.firstName +
      " " +
      gifttagg.lastName +
      " has sent you a very special video / voice message. To play, visit play.gifttagg.com & enter message code: " +
      gifttagg.code;
  } else if (gifttagg === undefined && magicWriter !== undefined) {
    message = magicWriter.message;
  } else if (gifttagg !== undefined && magicWriter !== undefined) {
    message =
      magicWriter.message +
      "\n\n" +
      gifttagg.firstName +
      " " +
      gifttagg.lastName +
      " has sent you a very special video / voice message. To play, visit play.gifttagg.com & enter message code: " +
      gifttagg.code;
  }

  message == "" && window.sessionStorage.removeItem("giftMessage");

  return message;
};

const config = {
  widget: {
    containerId: "magic-writer-element",
    generateGiftnote: handleGenerateGiftnote,
  },
  magicWriter: {
    magicWriterMaxChars: 300,
    maxGenerations: 10,
    homePage: {
      disabled: true,
      includeGiftNoteInWidget: true,
      generateButtonVisible: true,
      dividerVisible: true,
      gifttaggVisible: true,
      placeHolderForEmbedGiftNote: "Hyy There",
    },
    formPage: {
      titleVisible: true,
      disableToField: false,
      disableFromField: false,
    },
    theme: {
      accentColor: "linear-gradient(90deg,var(--red),var(--pink))",
    },
    overrides: {
      overrideWidth: "100%",
    },
  },
  gifttagg: {
    functionality: {
      recordLaterEnabled: false,
    },
    theme: {
      name: "default",
    },
  },
};

// ============================================
// Magic Writer Initialization & MutationObserver
// ============================================

let giftingElement = document.getElementById("magic-writer-element");

if (giftingElement) {
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          // Hide save button when it appears
          if (node.id === "magic-writer-save-btn") {
            node.style.display = "none";
          }

          // Capture generated text from gift note container
          if (node.id === "magic-writer-gift-note") {
            const textarea = node.querySelector("textarea");
            if (textarea) {
              let textValue = textarea.value;
              generatedMessage = textValue;
              document.querySelector(".js-gift-note-text").style.display =
                "block";
              document.querySelector(".js-gift-note-text").value = textValue;
              const freshieImg = document.querySelector(".freshie__image");
              if (freshieImg) freshieImg.style.display = "none";
            }
          }

          // Title rename no longer needed — widget already says "Freshie"
        });

        if (
          mutation.target.value != "" &&
          mutation.target.value != undefined &&
          mutation.target.value != null
        ) {
          document.querySelector(".js-gift-note-text").style.display = "block";
          document.querySelector(".js-gift-note-text").value =
            mutation.target.value;
        }
      }
    }
  };
  const observer = new MutationObserver(callback);

  observer.observe(giftingElement, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  // Initialize old gifttaggSDK for Magic Writer
  if (typeof gifttaggSDK !== "undefined") {
    var sdk = gifttaggSDK.Build(config);
  }
}

// ============================================
// Video Recording - New Giftie SDK ONLY
// ============================================

function openGiftTag() {
  // ONLY use new Giftie SDK for video recording
  if (!window.Giftie) {
    console.error(
      "[Giftie] SDK not loaded - make sure Giftie app is installed"
    );
    return;
  }

  window.Giftie.onVideoSave = async (data) => {
    console.log("📹 Giftie video saved:", data);

    if (!data?.videoCode) {
      console.warn("[Giftie] Missing video code from SDK");
      return;
    }

    // Update button UI in modal if present
    const openModal = document.querySelector(".modal__wrapper.show__modal");
    if (openModal) {
      const gtBtn = openModal.querySelector("#gt-add-video-btn");
      if (gtBtn) {
        gtBtn.setAttribute("gt-video-code", data.videoCode);
        gtBtn.innerText = "Saved";
        gtBtn.classList.add("gt-button-disabled");
      }
      openModal.classList.remove("Open-Gift-Model");
    }

    // Call the global callback if it exists (for theme.liquid integration)
    if (typeof window.gifttaggCallback === "function") {
      window.gifttaggCallback(
        data.videoCode,
        data.firstName || "",
        data.lastName || "",
        data.email || ""
      );
    }
  };

  window.Giftie.open();
}

// Store text message in session storage
function storeMessage() {
  // Normalize Unicode chars to ASCII so atob() in product-form.js decodes cleanly
  var safeMessage = generatedMessage
    .replace(/[\u2018\u2019\u201A]/g, "'")
    .replace(/[\u201C\u201D\u201E]/g, '"')
    .replace(/\u2026/g, "...")
    .replace(/[\u2013\u2014]/g, "-")
    .replace(/\u00A0/g, " ");
  window.sessionStorage.setItem("giftMessage", btoa(safeMessage));
}

// ============================================
// Freshie character animation (homepage)
// ============================================

var freshieImage = document.querySelector(".freshie__guy-image");
if (freshieImage) {
  freshieImage.addEventListener(
    "click",
    function (element) {
      freshieImage.parentElement.style.opacity = 1;
    },
    false
  );
}

let toggleFreshieGuy = () => {
  if (document.querySelector(".section-gift-form")) {
    const giftSection = document.querySelector(".section-gift-form"),
      rect = giftSection.getBoundingClientRect();
    giftSection
      .querySelector(".gift__form-right")
      .classList.toggle("visible", rect.top - (rect.height - 500) <= 0);
  }
};

window.onscroll = toggleFreshieGuy;

